import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { getMissionLateQuery } from "./queries";
import { useUserContext } from "api/user/UserProvider";
import { LATE_MISSION_TYPE, QUERY_STATUS } from "constants/constants";

const DashboardMissionLateContext = createContext({});

export const useDashboardMissionLateContext = () =>
  useContext(DashboardMissionLateContext);

export const DashboardMissionLateProvider = ({ ...props }) => {
  const { userScope } = useUserContext();
  const [missionCreatedLateList, setMissionCreatedLateList] = useState([]);
  const [missionClosedLateList, setMissionClosedLateList] = useState([]);
  const [missionClosedInTimeList, setMissionClosedInTimeList] = useState([]);
  const [getMissionLateListStatus, setGetMissionLateListStatus] = useState(
    QUERY_STATUS.INITIAL
  );

  const getMissionLateList = useCallback(
    async ({ manager_id, type }) => {
      try {
        const result = await getMissionLateQuery({
          manager_id,
          type,
          userScope,
        });
        if (type === LATE_MISSION_TYPE.CREATED_LATE)
          setMissionCreatedLateList(result);
        if (type === LATE_MISSION_TYPE.CLOSED_LATE)
          setMissionClosedLateList(result);
        if (type === LATE_MISSION_TYPE.CLOSED_IN_TIME)
          setMissionClosedInTimeList(result);
        setGetMissionLateListStatus(QUERY_STATUS.SUCCESS);
      } catch (error) {
        setGetMissionLateListStatus(QUERY_STATUS.ERROR);
        console.error(error);
      }
    },
    [userScope]
  );

  const values = useMemo(
    () => ({
      missionCreatedLateList,
      missionClosedLateList,
      missionClosedInTimeList,
      getMissionLateList,
      getMissionLateListStatus,
    }),
    [
      missionCreatedLateList,
      missionClosedLateList,
      missionClosedInTimeList,
      getMissionLateList,
      getMissionLateListStatus,
    ]
  );
  return <DashboardMissionLateContext.Provider value={values} {...props} />;
};
